import { render, staticRenderFns } from "./StepperCol.vue?vue&type=template&id=a454758c"
import script from "./StepperCol.vue?vue&type=script&lang=js"
export * from "./StepperCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports